import { useCallback, useMemo } from 'react'
// import { useTokenProjectsQuery } from 'uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks' // 🚨 不存在
import { GqlResult } from 'uniswap/src/data/types'
import { CurrencyInfo } from 'uniswap/src/features/dataApi/types'
import { currencyIdToContractInput } from 'uniswap/src/features/dataApi/utils'
import { CurrencyId } from 'uniswap/src/types/currency'

/**
 * Fetches token information as CurrencyInfo from currencyIds. When used, wrap component
 * with Suspense.
 */
export function useTokenProjects(currencyIds: CurrencyId[]): GqlResult<CurrencyInfo[]> {
  // 🚨 TokenProjects查询已被完全禁用，因为：
  // 1. 后端服务不支持此接口
  // 2. useTokenProjectsQuery hook不存在
  // 保留原有的参数处理逻辑以维持接口兼容性
  const contracts = useMemo(() => currencyIds.map((id) => currencyIdToContractInput(id)), [currencyIds])



  // 🚨 直接返回空数据，不进行任何GraphQL查询
  const formattedData = useMemo(() => {
    console.log('🔍 TokenProjects已禁用，返回空数据')
    return [] // 返回空数组而不是undefined，避免组件等待数据
  }, [])

  const retry = useCallback(() => {
    console.log('🔍 TokenProjects重试被跳过（查询已禁用）')
    // 由于查询被禁用，重试也不执行任何操作
  }, [])

  // 直接返回成功状态和空数据
  return { 
    data: formattedData, 
    loading: false, // 不需要加载状态
    refetch: retry, 
    error: null // 没有错误
  }
}
